import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from '../../../../../../ng2-bootstrap-modal/dialog.component';
import {DialogService} from '../../../../../../ng2-bootstrap-modal/dialog.service';
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {HostingService} from "../../hosting.service";
import { filter, first } from "rxjs";

export interface IGeneratePasswordData {
  websiteId: number;
  generatingFor: string;
}
@Component({
    selector: 'db-generate-password',
    templateUrl: './generate-password.component.html',
    styleUrls: ['./generate-password.component.scss'],
    standalone: false
})
export class GeneratePasswordComponent extends DialogComponent<IGeneratePasswordData, Boolean> implements OnInit, IGeneratePasswordData {

  @Input() websiteId: number;
  @Input() generatingFor: string = 'sftp';

  public changes: any;
  public loading: boolean;

  constructor(
    private _dialogService: DialogService,
    private _hostingService: HostingService
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {

  }

  public generateSftpPassword(): void {
    this.loading = true;
    this._hostingService.generateSftpPassword( this.websiteId )
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          // this.getData();
          this.loading = false;
          this.confirm();
        }
        else {
          this.close();
        }
      });
  }



  public generateMySqlPassword(): void {
    this.loading = true;
    this._hostingService.generateMysqlPassword( this.websiteId )
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          // this.getData();
          this.loading = false;
          this.confirm();
        }
        else {
          this.close();
        }
      });
  }

  public cancel(): void {
    this.result = false;
    this.close();
  }

  public confirm(): void {
    this.result = true;
    this.close();
  }

}
